import React from 'react';
import Navbar from '../components/Navbar';
import Signin from '../components/Signin';

const SigninPage = () => {
  return (
    <div>
      <Navbar />
      <div style={{ paddingTop: '200px' }}>
      <Signin />
      </div>
    </div>
  );
};

export default SigninPage;
